import { Injectable, inject } from '@angular/core';
import { AuthorizationParams } from '@auth0/auth0-angular';
import { UserProfile } from '@rockwell-automation-inc/common-utils';
import { AuthService } from '@rockwell-automation-inc/service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly authService = inject(AuthService);

  isAuthenticated$ = this.authService.isAuthenticated$;
  user$: Observable<UserProfile> = this.authService.user$;
  error$ = this.authService.error$;

  login(authParams?: AuthorizationParams, targetPath?: string): void {
    this.authService.login(authParams, targetPath);
  }

  logout(): void {
    this.authService.logout();
  }

  getAccessToken$(): Observable<string> {
    return this.authService.getAccessToken$();
  }

  checkAuth0Session(): Promise<boolean> {
    return this.authService.checkAuth0Session();
  }
}
